import { CHANNELS } from "../shared/channels";
import { AwardsSummary, BoardEntry, Unlock } from "../shared/achievements";
import { call, listen } from "./bridge";
import { flashToast } from "./dom";
import { t } from "./i18n";
import { canUse } from "./me";

// one copy of this person's awards and the leaderboard for every part of the screen that shows them

let summary: AwardsSummary | null = null;
let board: BoardEntry[] = [];
let loading: Promise<void> | null = null;
const listeners: Array<() => void> = [];

export const awardsNow = (): AwardsSummary | null => summary;
export const boardNow = (): BoardEntry[] => board;

export function onAwards(listener: () => void): void {
  listeners.push(listener);
}

export function loadAwards(): Promise<void> {
  if (!canUse("awards", "edit")) return Promise.resolve();
  loading ??= Promise.all([call<AwardsSummary>(CHANNELS.awardsGet), call<BoardEntry[]>(CHANNELS.awardsBoard)])
    .then(([mine, ranks]) => {
      summary = mine;
      board = ranks;
      listeners.forEach((listener) => listener());
    })
    .catch(() => undefined)
    .finally(() => {
      loading = null;
    });
  return loading;
}

export function remember(next: AwardsSummary): void {
  summary = next;
  listeners.forEach((listener) => listener());
}

let lastVisit = 0;

// tells the server this person is here today, with their own clock so streaks and night owls follow their time zone
export function sendVisit(): void {
  if (!canUse("awards", "edit") || Date.now() - lastVisit < 20 * 60_000) return;
  lastVisit = Date.now();
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, "0");
  const day = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  void call<AwardsSummary>(CHANNELS.awardsEvent, "visit", { day, hour: now.getHours(), dow: now.getDay() }).then(remember).then(() => loadAwards()).catch(() => undefined);
}

export function localDay(): string {
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function setupAwardsStore(): void {
  listen(CHANNELS.awardsUpdated, () => void loadAwards());
  listen<Unlock>(CHANNELS.awardsUnlocked, (unlock) => {
    const lines = [
      ...unlock.achievements.map((item) => t("achievement: {name} +{points}", { name: t(item.name), points: item.points })),
      ...(unlock.medalCount && unlock.medalCount > unlock.medals.length ? [t("{count} new medals", { count: unlock.medalCount })] : unlock.medals.map((item) => t("medal earned: {name}", { name: t(item.name) })))
    ];
    if (lines.length) flashToast(lines.slice(0, 2).join(" · "));
  });
}
